var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            !_vm.optedOut
              ? _c("div", { staticClass: "col-md-4" }, [
                  _c("img", {
                    staticClass: "optout",
                    attrs: {
                      src: require("@/assets/img/optout.svg?data"),
                      alt: "No opt-out access"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.optout.noAccessOptoutText)
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.optedOut
              ? _c("div", { staticClass: "col-md-4" }, [
                  _c("img", {
                    staticClass: "checksquare",
                    attrs: {
                      src: require("@/assets/img/check-square.svg?data"),
                      alt: "Checkmark indicator"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.optout.resetConsentText)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.optout.optoutDisclaimer)
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2de4ef6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de4ef6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptOut.vue
// module id = null
// module chunks = 